import { useAPIGetSummary } from 'api/kinerja/tim-penilai-ps/landing-page'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { TSummary } from 'types/kinerja-tim-penilai-ps'

type TUseSummaryHooks = {
  summary: TSummary
  apiStatus: string
}

export const useSummary = (): TUseSummaryHooks => {
  const { period, isHavePeriod } = usePeriodContext()
  const { data: summary, status: apiStatus } = useAPIGetSummary({
    periodId: period.id,
    enabled: isHavePeriod,
  })

  return {
    summary,
    apiStatus,
  }
}
